<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const LiveCasinoIcon = getIcon("LiveCasinoIcon");
</script>

{#if typeof LiveCasinoIcon === 'string'}
	<img src={LiveCasinoIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof LiveCasinoIcon === 'function'}
	<svelte:component this={LiveCasinoIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
